import React, { useEffect } from "react";
import { Modal, Text, Icon, cn } from "@artprov/design-system";

/*
Se creo este componente ya que el provisto por la libreria DesignSystem no provee la opcion
de definir la cantidad de botones a mostrar, en ese caso se requiere uno solo
*/

export const FeedbackModal = ({
  open,
  setOpen = () => { },
  title,
  message,
  variant,
  labelAccept,
  labelCancel,
  onCancel,
  onAccept = () => { },
  onIconClose = () => { },
  children,
  className,
  classNameFooter = "",
}) => {
  const IconBody = ({ variant = "success" }) => {
    const iconName = {
      success: "check_circle",
      error: "cancel",
      warning: "error",
    }[variant];

    const iconColor = {
      success: "text-success-10",
      error: "text-error-10",
      warning: "text-warning-10",
    }[variant];

    return (
      <Icon
        icon={iconName}
        className="py-4"
        classNameIcon={cn(iconColor)}
        size="extra-large"
      />
    );
  };

  const Header = ({ children, className = "" }) => {
    return (
      <div className={cn("flex justify-between items-start h-20 ", className)}>
        {children}
      </div>
    );
  };

  const Body = ({ children, className = "" }) => {
    return (
      <div className={cn("px-4 h-36 flex flex-col items-center", className)}>
        {children}
      </div>
    );
  };
  const Title = ({ children, className = "" }) => {
    return (
      <Text
        variant="h5"
        className={cn("text-primary-10 py-4 h-min", className)}>
        {children}
      </Text>
    );
  };

  const Message = ({ children, className = "" }) => {
    return (
      <Text
        variant="body1"
        className={cn(
          "text-primary-10 px-4 h-min flex text-center ",
          className
        )}>
        {children}
      </Text>
    );
  };

  const Footer = ({ children, className = "" }) => {
    return (
      <div
        className={cn(
          "flex justify-center items-center px-4 h-25 mt-15",
          className
        )}>
        {children}
      </div>
    );
  };

  const divideMessage = (message) => {
    const messageFormated = message?.split("|");
    return messageFormated;
  };

  useEffect(() => {
    if (variant == "success") {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          onIconClose();
        }
      };
      window.addEventListener("keydown", handleKeyDown);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [variant]);

  return (
    <Modal.Container open={open} setOpen={setOpen} closeOnClickOutside={false}>
      <Modal.Content className={cn("w-[411px] h-[294px] ", className)}>
        <Header>
          <div className="size-14" />
          <IconBody variant={variant} />
          <Modal.Close
            onClose={() => {
              onIconClose();
            }}
          />
        </Header>
        <Body className="h-auto text-center">
          <>
            <Title>{title}</Title>
            {divideMessage(message).map((element, i) => {
              const classMargin =
                divideMessage(message).length - 1 == i ? "" : "mb-2";
              return (
                <Message
                  key={"key_" + i}
                  className={cn(
                    "text-tertiary-10",
                    classMargin
                  )}>
                  {element}
                </Message>
              );
            })}
          </>
        </Body>
        <Footer >
          {children || (
            <div className={cn("flex")}>{onCancel &&
              <Modal.CancelButton onClick={onCancel}>
                {labelCancel}
              </Modal.CancelButton>}
              <Modal.AcceptButton onClick={onAccept}>
                {labelAccept}
              </Modal.AcceptButton>
            </div>
          )}
        </Footer>
      </Modal.Content>
    </Modal.Container>
  );
};
